(function() {
	'use strict';

	angular.module('app.core')
    .service('storeService', storeService);
    
	storeService.$inject = [];

	function storeService() {
		var store = leandnaStore;

		return {
			loadReportSettings: store.loadReportSettings,
			loadSavedView: store.loadSavedView,
			updateFilterSettings: store.updateFilterSettings,
			subscribe: store.subscribe,
			getState: function() { return Object.freeze(store.getState()); },
			dispatch: store.dispatch,
			actions: store.actions,
			actionCreators: store.actionCreators,
			loadMyViews: store.loadMyViews,
			loadFirstViews: store.loadFirstViews,
			setFirstView: store.setFirstView,
			updateView: store.updateView,
			deleteView: store.deleteView,
			postNewView: store.postNewView,
			buildReportSettingsUrl: store.buildReportSettingsUrl,
			getMyViewsForAppSection: store.getMyViewsForAppSection,
			createReact18Root: store.createReact18Root,
			mountReact18Component: store.mountReact18Component,
			ReportButtons: store.ReportButtons,
			DashboardButtons: store.DashboardButtons,
			UnauthorizedSharedView: store.UnauthorizedSharedView,
			addMandatoryDefaultFilters: store.addMandatoryDefaultFilters,
			addDefaultFilters: store.addDefaultFilters,
			getSuppliers: store.getSuppliers,
			updateViewState: store.updateViewState,
			getBucketHeaders: store.getBucketHeaders,
			chat: store.chat,
			thunks: store.thunks,
			dateUtils: store.dateUtils,
			trackPageView: store.trackPageView,
			formatterService: store.formatterService,
			dataPipelineUtils: store.dataPipelineUtils,
			toHex: store.toHex
		};
	}
})();